export default __webpack_public_path__ + "static/media/logo_bdu.15c9e389.png";